export default __webpack_public_path__ + "static/media/dashboard-saas.cfcb8f7f.jpg";